import { initReactI18next } from "react-i18next";
import i18n from "i18next";
var GameVolatility = /* @__PURE__ */ ((GameVolatility2) => {
  GameVolatility2["High"] = "HIGH";
  GameVolatility2["Medium"] = "MEDIUM";
  GameVolatility2["Low"] = "LOW";
  return GameVolatility2;
})(GameVolatility || {});
var GameCharacteristic = /* @__PURE__ */ ((GameCharacteristic2) => {
  GameCharacteristic2["Name"] = "NAME";
  GameCharacteristic2["Developer"] = "DEVELOPER";
  GameCharacteristic2["ReleaseDate"] = "RELEASE_DATE";
  GameCharacteristic2["Theme"] = "THEME";
  GameCharacteristic2["Type"] = "TYPE";
  GameCharacteristic2["Rtp"] = "RTP";
  GameCharacteristic2["Volatility"] = "VOLATILITY";
  GameCharacteristic2["ReelsNumber"] = "REELS_NUMBER";
  GameCharacteristic2["PayLines"] = "PAY_LINES";
  GameCharacteristic2["MinBet"] = "MIN_BET";
  GameCharacteristic2["MaxBet"] = "MAX_BET";
  GameCharacteristic2["MaxWin"] = "MAX_WIN";
  GameCharacteristic2["Compatibility"] = "COMPATIBILITY";
  GameCharacteristic2["HasDemo"] = "HAS_DEMO";
  GameCharacteristic2["HasAutoplay"] = "HAS_AUTOPLAY";
  GameCharacteristic2["HasFreeSpins"] = "HAS_FREE_SPINS";
  GameCharacteristic2["HasFastSpin"] = "HAS_FAST_SPIN";
  GameCharacteristic2["HasBonusPurchase"] = "HAS_BONUS_PURCHASE";
  GameCharacteristic2["HasCollectionSymbols"] = "HAS_COLLECTION_SYMBOLS";
  GameCharacteristic2["HasProgressiveJackpot"] = "HAS_PROGRESSIVE_JACKPOT";
  GameCharacteristic2["BonusFeatures"] = "BONUS_FEATURES";
  GameCharacteristic2["Languages"] = "LANGUAGES";
  return GameCharacteristic2;
})(GameCharacteristic || {});
const pageNotFound$1 = {
  title: "404 — Page not found",
  description: "Sorry 😔, we couldn’t find what you were looking for.",
  action: "Go Home"
};
const footer$1 = {
  copyright: "© {{year}} {{domain}}. All rights reserved.",
  disclaimer: {
    title: "Play responsibly: ",
    description: "{{domain}} is an independent resource not affiliated with the sites we promote. Make sure you have all the necessary certifications and legal requirements are met before you start playing. The main purpose of {{domain}} is to provide informative and entertaining content. If you are looking for links to related resources, you will be redirected to the relevant platforms."
  }
};
const gameDemo$1 = {
  warning: "Your browser is too old to display the iframe element",
  action: {
    playForFree: "Play for Free",
    activateFullscreen: "Activate Fullscreen mode",
    deactivateFullscreen: "Deactivate Fullscreen mode"
  }
};
const gameInfo$1 = {
  title: "Game Info",
  group: {
    general: "General Characteristics",
    features: "Game Features"
  },
  feature: {
    [GameCharacteristic.BonusFeatures]: "Bonus Features",
    [GameCharacteristic.Compatibility]: "Compatibility",
    [GameCharacteristic.Developer]: "Developer",
    [GameCharacteristic.HasAutoplay]: "Autoplay",
    [GameCharacteristic.HasBonusPurchase]: "Bonus Purchase",
    [GameCharacteristic.HasCollectionSymbols]: "Collection Symbols",
    [GameCharacteristic.HasDemo]: "Demo Version",
    [GameCharacteristic.HasFastSpin]: "Fast Spin",
    [GameCharacteristic.HasFreeSpins]: "Free Spins",
    [GameCharacteristic.HasProgressiveJackpot]: "Progressive Jackpot",
    [GameCharacteristic.Languages]: "Languages",
    [GameCharacteristic.MaxWin]: "Max Win",
    [GameCharacteristic.MaxBet]: "Max Bet",
    [GameCharacteristic.MinBet]: "Min Bet",
    [GameCharacteristic.Name]: "Name",
    [GameCharacteristic.PayLines]: "Pay Lines Number",
    [GameCharacteristic.ReelsNumber]: "Reels Number",
    [GameCharacteristic.ReleaseDate]: "Release Date",
    [GameCharacteristic.Rtp]: "RTP",
    [GameCharacteristic.Theme]: "Theme",
    [GameCharacteristic.Type]: "Type",
    [GameCharacteristic.Volatility]: "Volatility"
  },
  value: {
    boolean: {
      true: "Yes",
      false: "No"
    },
    volatility: {
      [GameVolatility.High]: "High",
      [GameVolatility.Medium]: "Medium",
      [GameVolatility.Low]: "Low"
    }
  }
};
const prosCons$1 = {
  advantages: "Advantages",
  disadvantages: "Disadvantages"
};
const author$1 = {
  title: "Published by",
  action: {
    expand: "Show more",
    collapse: "Hide"
  }
};
const contactForm$1 = {
  field: {
    name: {
      label: "Name",
      placeholder: "Your Name"
    },
    email: {
      label: "Email",
      placeholder: "Your Email"
    },
    message: {
      label: "Message",
      placeholder: "Your Message"
    }
  },
  notification: {
    title: "{{name}}, thank you for your feedback!",
    description: "We will get back to you at {{email}} as soon as possible."
  },
  action: {
    send: "Send Message"
  }
};
const dictionary$1 = {
  pageNotFound: pageNotFound$1,
  footer: footer$1,
  gameDemo: gameDemo$1,
  gameInfo: gameInfo$1,
  prosCons: prosCons$1,
  author: author$1,
  contactForm: contactForm$1
};
const pageNotFound = {
  title: "404 — Pagina non trovata",
  description: "Spiacenti 😔, non siamo riusciti a trovare quello che cercavi.",
  action: "Ritorna alla pagina principale"
};
const footer = {
  copyright: "© {{year}} {{domain}}. Tutte le cose sono fatte.",
  disclaimer: {
    title: "Gioca responsabilmente: ",
    description: "{{domain}} è una risorsa indipendente e non affiliata ai siti che promuoviamo. Prima di iniziare a giocare, assicurati di possedere tutte le certificazioni necessarie e di rispettare i requisiti legali in vigore. L'obiettivo principale di {{domain}} è offrire contenuti informativi e di intrattenimento. Se cerchi collegamenti a risorse correlate, verrai reindirizzato alle piattaforme pertinenti."
  }
};
const gameDemo = {
  warning: "Il tuo browser è troppo vecchio per visualizzare l'elemento iframe",
  action: {
    playForFree: "Gioca gratis",
    activateFullscreen: "Attiva la modalità a schermo intero",
    deactivateFullscreen: "Disattiva la modalità a schermo intero"
  }
};
const gameInfo = {
  title: "Informazioni sul gioco",
  group: {
    general: "Caratteristiche principali",
    features: "Gioco e funzionalità"
  },
  feature: {
    [GameCharacteristic.BonusFeatures]: "Funzionalità Bonus",
    [GameCharacteristic.Compatibility]: "Compatibilità",
    [GameCharacteristic.Developer]: "Sviluppatore",
    [GameCharacteristic.HasAutoplay]: "Autoplay",
    [GameCharacteristic.HasBonusPurchase]: "Acquisto Bonus",
    [GameCharacteristic.HasCollectionSymbols]: "Simboli da Collezione",
    [GameCharacteristic.HasDemo]: "Versione Demo",
    [GameCharacteristic.HasFastSpin]: "Spin Veloce",
    [GameCharacteristic.HasFreeSpins]: "Giri Gratuiti",
    [GameCharacteristic.HasProgressiveJackpot]: "Jackpot Progressivo",
    [GameCharacteristic.Languages]: "Lingue",
    [GameCharacteristic.MaxWin]: "Vincita Massima",
    [GameCharacteristic.MaxBet]: "Puntata Massima",
    [GameCharacteristic.MinBet]: "Puntata Minima",
    [GameCharacteristic.Name]: "Nome",
    [GameCharacteristic.PayLines]: "Numero di Linee di Pagamento",
    [GameCharacteristic.ReelsNumber]: "Numero di Rulli",
    [GameCharacteristic.ReleaseDate]: "Data di Rilascio",
    [GameCharacteristic.Rtp]: "RTP",
    [GameCharacteristic.Theme]: "Tema",
    [GameCharacteristic.Type]: "Tipo",
    [GameCharacteristic.Volatility]: "Volatilità"
  },
  value: {
    boolean: {
      true: "Sì",
      false: "No"
    },
    volatility: {
      [GameVolatility.High]: "Alta",
      [GameVolatility.Medium]: "Media",
      [GameVolatility.Low]: "Bassa"
    }
  }
};
const prosCons = {
  advantages: "Vantaggi",
  disadvantages: "Svantaggi"
};
const author = {
  title: "Informazioni sull'autore",
  action: {
    expand: "Mostra per intero",
    collapse: "Nascondere"
  }
};
const contactForm = {
  field: {
    name: {
      label: "Nome",
      placeholder: "Il tuo Nome"
    },
    email: {
      label: "Email",
      placeholder: "La tua Email"
    },
    message: {
      label: "Messaggio",
      placeholder: "Il tuo Messaggio"
    }
  },
  notification: {
    title: "{{name}}, grazie per il tuo feedback!",
    description: "Ti risponderemo all’indirizzo {{email}} il prima possibile."
  },
  action: {
    send: "Invia Messaggio"
  }
};
const dictionary = {
  pageNotFound,
  footer,
  gameDemo,
  gameInfo,
  prosCons,
  author,
  contactForm
};
const resources = {
  en: dictionary$1,
  it: dictionary
};
const DEFAULT_LANGUAGE = "en";
i18n.use(initReactI18next).init({
  fallbackLng: DEFAULT_LANGUAGE,
  resources
});
export {
  GameVolatility as G,
  GameCharacteristic as a,
  resources as r
};
